import { EFinancingProgram } from '@if/core/types'
import { useCreateCreditApplication } from '@src/data/api/credit-application/credit-application-api'
import { useFinancingConfig } from '@src/data/selectors/app-config-selectors'
import { useState, type JSX } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { Breadcrumb, PageSpinner } from '../../components'
import { buildDraftCreditApplicationSchema, CreditApplication } from '../../data/types'
import { reportErrorToServer } from '../../services/error-logger'
import CreditApplicationForm from './components/CreditApplicationForm/CreditApplicationForm'

const CreateCreditApplicationPage = (): JSX.Element => {
  const { t } = useTranslation()
  const [createCreditApplication, isCreating] = useCreateCreditApplication()
  const navigate = useNavigate()
  const { financingProgramId } = useParams<{ financingProgramId: EFinancingProgram }>()
  const financingConfig = useFinancingConfig(financingProgramId)

  const [creditApplication] = useState<CreditApplication>({
    ...(buildDraftCreditApplicationSchema({ financingConfig }).getDefault() as unknown as CreditApplication),
    financingProgramId: financingProgramId!,
  })
  document.title = t('breadcrumbs.newApplication')
  const onSave = (data: Partial<CreditApplication>) => {
    createCreditApplication(data)
      .then((creditApp) => {
        navigate(`/Applications/${creditApp.financingProgramId}/${creditApp.id}/view`, { replace: true })
      })
      .catch(reportErrorToServer)
  }

  const breadCrumbs = [
    { path: '/', label: t('breadcrumbs.home') },
    { path: '/Applications/browse', label: t('breadcrumbs.creditApplication') },
    { path: '#', label: t('breadcrumbs.newApplication') },
  ]

  return (
    <div>
      <PageSpinner isLoading={isCreating} withBackdrop />
      <Breadcrumb trees={breadCrumbs} />
      <CreditApplicationForm creditApplication={creditApplication} onSave={onSave} />
    </div>
  )
}

export default CreateCreditApplicationPage
